import { useNavigate } from "react-router-dom";
import "./guest-signup.scss";
import googleLogo from "../../../assets/media/icons/googleLogo.png";
import TrowelIcon from "../../../components/icon";

const GuestSignup: React.FC = () => {

  const navigate = useNavigate();
  
  return (
    <div className="guest-sign-up-wrapper row">
      <div className="guest-sign-up-wrapper__left ">
        <span className="signup-label">Sign Up</span>
        <span className="signup-text">
          Lorem ipsum dolor sit amet adipiscing elit.
        </span>

        <input className="twl-input-text" type="text" placeholder="Your name" />
        <input className="twl-input-text" type="text" placeholder="Email" />
        <input
          className="twl-input-text"
          type="password"
          placeholder="Password"
        />

        <div className="signup-button" onClick={()=>navigate('/signup-s1')}>Sign up</div>

        <hr />

        <div className="signup-with-button">
          <TrowelIcon src={googleLogo} />
          {/* <span>G</span> */}
          <span>Sign up with Google</span>
        </div>

        <div className="signup-with-button">
          <span>F</span>
          <span>Sign up with Facebook</span>
        </div>

        <div className="signup-with-button">
          <span>I</span>
          <span>Sign up with Instagram</span>
        </div>

        <div>
          Already have an account ? <span className="signup-link">Log in</span>
        </div>
      </div>
      <div className="guest-sign-up-wrapper__right"></div>
    </div>
  );
};

export default GuestSignup;
